<template>
  <div class="container">
    <!--      <h2 class="text-center" data-animate='{"class":"fadeInUp"}'>My EOPP</h2>-->
    <div class="row row-30 row-md-40 justify-content-center">
      <div class="col-sm-6 col-lg-5" data-animate='{"class":"fadeInUp"}'>
        <!-- Blurb modern-->
        <router-link to="/opportunities/">
          <article class="article-box-large blurb blurb-boxed p-4">
            <div class="blurb-header m-0">
              <div class="blurb-embed"><span class="blurb-number h2">01</span></div>
              <div class="blurb-title h4">My Opportunities</div>
            </div>
            <hr class="blurb-divider divider divider-sm m-0">
            <template v-if="!preferredProgram">
              <div class="blurb-txt h6">We have following programs for you to select</div>
              <ul class="pricing-box-list">
                <li v-for="res in (possiblePrograms || []).slice(0,3)" v-bind:key="res.code">
                  <div class="p-1 pt-2">
                    <img class="novi-icon" :src="'/images/countries/'+res.country_code+'.png'" width="40"><span class="ml-1">{{ res.name }}</span>
                  </div>
                </li>
                <template v-if="(possiblePrograms ||[]).length === 0 ">
                  <li v-for="res in (qualifiedPrograms || []).slice(0,3)" v-bind:key="res.code">
                    <div class="p-1 pt-2">
                      <img class="novi-icon" :src="'/images/countries/'+res.country_code+'.png'" width="40"><span class="ml-1">{{ res.name }}</span>
                    </div>
                  </li>

                </template>
              </ul>
              <div class="blurb-txt">Please make your choice and select most suited visa program for you.</div>
              <div><b>Select</b> <span class="btn-icon int-arrow-right icon-xs novi-icon"></span></div>
            </template>
            <template v-else>
              <div class="blurb-title h6">Your preferred program</div>
              <div class="blurb-txt" v-if="preferredProgram">
                <img :src="'/images/countries/'+preferredProgram.country_code+'.png'" style="width: 2em">
                <span style="font-size: large"><strong>{{ (preferredProgram || {}).name }}</strong></span>
              </div>
              <p>You also
                <span v-if="possiblePrograms.length === 2"> has <strong>One</strong> other option to choose</span>
                <span v-if="possiblePrograms.length === 3"> have <strong>Two</strong> other options to choose</span>
                <span v-if="qualifiedPrograms.length > 0">
                    <span v-if="qualifiedPrograms.length === 1"> and <strong>one</strong> other possible option</span>
                    <span v-else> and <strong>{{ qualifiedPrograms.length }}</strong> other possible options</span>
                    <span> by improving your qualifications </span>
                  </span>
              </p>
              <div><b>View All</b> <span class="btn-icon int-arrow-right icon-xs novi-icon"></span></div>
            </template>
          </article>
        </router-link>
      </div>
      <div class="col-sm-6 col-lg-5" data-animate='{"class":"fadeInUp"}'>
        <!-- Blurb modern-->
        <router-link to="/documents/">
          <article class="article-box-large blurb blurb-boxed blurb-secondary p-4">
            <div class="blurb-header">
              <div class="blurb-embed"><span class="blurb-number h2">02</span></div>
              <div class="blurb-title h4">Upload Documents</div>
            </div>
            <hr class="blurb-divider divider divider-sm">
            <div class="blurb-text">Upload your documents.</div>
            <!--              <span v-if="lastDocUpdated !== undefined">Last upload on {{ lastDocUpdated.timeid | formatTimeId }}</span>-->
            <div><b>View All</b> <span class="btn-icon int-arrow-right icon-xs novi-icon"></span></div>
          </article>
        </router-link>
      </div>
      <div class="col-sm-6 col-lg-5" data-animate='{"class":"fadeInUp"}'>
        <article class="article-box-small blurb blurb-boxed p-4 pointer" @click="proceedToEdu">
          <div class="blurb-header">
            <div class="blurb-embed"><span class="blurb-number h2">03</span></div>
            <div class="blurb-title h4">Education Qualifications</div>
          </div>
          <hr class="blurb-divider divider divider-sm">
          <div class="blurb-text">
            Add details on your education qualifications
          </div>
          <div><b>Select</b> <span class="btn-icon int-arrow-right icon-xs novi-icon"></span></div>
        </article>
        <!--        </router-link>-->
      </div>
      <div class="col-sm-6 col-lg-5" data-animate='{"class":"fadeInUp"}'>
          <article class="article-box-small blurb blurb-boxed p-4" @click="proceedToLanguage">
            <div class="blurb-header">
              <div class="blurb-embed"><span class="blurb-number h2">04</span></div>
              <div class="blurb-title h4">English Language Certification</div>
            </div>
            <hr class="blurb-divider divider divider-sm">
            <div class="blurb-text">
              Add details on your English Language Certification status and grades
            </div>
            <div><b>Select</b> <span class="btn-icon int-arrow-right icon-xs novi-icon"></span></div>
          </article>
      </div>
      <div class="col-sm-6 col-lg-5" data-animate='{"class":"fadeInUp"}'>
<!--        <router-link to="/course-options/">-->
          <article class="article-box-small blurb blurb-boxed blurb-info p-4" @click="proceedToCourse">
            <div class="blurb-header">
              <div class="blurb-embed"><span class="blurb-number h2">05</span></div>
              <div class="blurb-title h4">University and Course Options</div>
            </div>
            <hr class="blurb-divider divider divider-sm">
            <div class="blurb-text">
              Add details on your education qualifications and select your university
            </div>
            <div><b>Select</b> <span class="btn-icon int-arrow-right icon-xs novi-icon"></span></div>
          </article>
<!--        </router-link>-->
      </div>
      <div class="col-sm-6 col-lg-5" data-animate='{"class":"fadeInUp"}'>
        <!-- Blurb modern-->
        <article class="article-box-small blurb blurb-boxed p-4">
          <div class="blurb-header">
            <div class="blurb-embed"><span class="blurb-number h2">04</span></div>
            <div class="blurb-title h4">My Profile</div>
          </div>
          <hr class="blurb-divider divider divider-sm">
          <div class="blurb-text">&nbsp;
            <button class="btn btn-block btn-warning" v-on:click="signOut()">Sign Out</button>&nbsp;
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue'
import {Auth} from "aws-amplify";
import eoppService from "@/mixins/EoppService";
import actRouter from "../ActRouter";
import {alertController} from "@ionic/vue";

export default {
  name: "NavLinks",
  mixins: [eoppService],
  data() {
    return {
      messageClicked: false
    }
  },
  computed: {
    lastDocUpdated() {
      return (this.lead && this.lead.highlights || []).find(h => h.code === 'doc_updated')
    }
  },
  methods: {
    signOut: function () {
      try {
        Auth.signOut();
      } catch (error) {
        console.log('error signing out: ', error);
      }
      this.$router.push({name: 'Login'});
    },
    async proceedToEdu() {
      console.log(this.qualifiedPrograms);
      if (!this.preferredProgram) {
        await this.selectProgram();
      }

      actRouter.push({path: '/education'})
    },
    async proceedToLanguage() {
      console.log(this.qualifiedPrograms);
      if (!this.preferredProgram) {
        await this.selectProgram();
      }

      actRouter.push({path: '/language'})
    },
    async proceedToCourse() {
      if (!this.lead || !this.lead.cf || !this.lead.cf.l2 ) {
        // await this.selectProgram();
        console.log('No L2');
        await this.presentAlert("Warning", "More Details Needed", "Please provide your Education and  English Language Qualifications")
        await actRouter.push({path: '/education'})
      } else {
        actRouter.push({path: '/course-options'})
      }
    },
    async selectProgram() {
      console.log(this.lead)
      return new Promise((resolve, reject) => {
        alertController
          .create({
            cssClass: 'program-select-popup',
            header: 'Alert',
            subHeader: 'Program Not Selected',
            message: 'Please select your preferred Visa Program',
            inputs: this.qualifiedPrograms.map(o => {
              return {label: o.name, type: 'radio', value: o.code}
            }),
            buttons: [
              {
                text: 'Cancel',
                role: 'cancel',
                cssClass: 'secondary',
                handler: () => {
                  console.log('Radio alert canceled');
                  reject('Cancelled');
                }
              }, {
                text: 'OK',
                handler: (data) => {
                  console.log('Selected option:', data);
                  this.saveSelectedProgram(data).then( res => resolve(res));
                }
              }
            ]
          }).then(alert => {
          alert.present();
        });

      })

      // const {role} = await alert.onDidDismiss();
      // console.log('onDidDismiss resolved with role', role);
    },
    saveSelectedProgram(prog) {
      return new Promise((resolve, reject) => {
        if (this.lead) {
          this.lead.cf.pref_program = prog;
          // this.lead.cf.pref_program = prog.code;
          this.$store.commit('pref_program', prog);
          // this.selectedProgram = prog;
          console.log(this.lead.cf.pref_program);
          this.updateCrmRecord([this.lead], null).then(res => {
            console.log(res);
            resolve('Updated');
          });
        } else {
          reject('No Lead')
        }
      });
    }
  },
  mounted() {
    if (!this.lead) {
      this.getAccountLead().then(res => {
        console.log(res.data);
        this.$store.commit('leadInfo', res.data);
      })
    }
  }
}
</script>

<style scoped>
.program-select-popup {
    min-width: 30em;
}

@media (min-width: 768px) {
    .program-select-popup {
        min-width: 30em;
    }

    .article-box-large {
        min-height: 20em;
    }

    .article-box-small {
        min-height: 15em;
    }

    .pointer {
        cursor: pointer;
    }
}
</style>
